import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import './Hero.css'

const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-overlay"></div>
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <span className="eyebrow">Stálsmíði · Rennismíði · Bátaviðgerðir</span>
        <h1>Traust handverk í yfir 30 ár</h1>
        <p>
          Við sérhæfum okkur í stálsmíði og véltækniþjónustu með áratuga reynslu
          og fagmennsku. Hvort sem um er að ræða sérsmíðaðar lausnir eða traust
          viðhald, tryggjum við gæði sem endast í krefjandi aðstæðum.
        </p>
        <div className="hero-actions">
          <Link to="/hafa-samband" className="btn btn-primary">Hafa samband</Link>
          <Link to="/thjonusta" className="btn btn-ghost">Skoða þjónustu</Link>
        </div>
      </motion.div>

      <div className="sponsors">
        <img src="/yanmar-logo-white.png" alt="Yanmar logo" />
        <img src="/volvo-penta-logo-white.png" alt="Volvo Penta logo" />
      </div>
    </div>
  )
}

export default Hero
